import axios from "axios";
import { config, recentlyViewedAxiosCancelToken } from "../../config";
import { recentlySearchedApiPrefix } from "../../paths";
import { RecentlySearchedCarsResponse } from "redmond";

const END_POINT: string = `${recentlySearchedApiPrefix}/cars`;

export const fetchRecentlySearchedCars =
  (): Promise<RecentlySearchedCarsResponse> =>
    new Promise(async (resolve, reject) => {
      try {
        const res = await axios.get(END_POINT, {
          baseURL: config.baseURL,
          cancelToken: recentlyViewedAxiosCancelToken.token,
        });
        resolve(res.data);
      } catch (e) {
        if (axios.isCancel(e)) {
          // do not reject if the error is a cancellation from the cancel token
          return;
        }
        reject(e);
      }
    });
